module.exports = __webpack_public_path__ + "static/media/pic1@2x.f91a6557.png";